<app-opportunities-header (feedback)="openFeedbackDialog()"></app-opportunities-header>
<router-outlet></router-outlet>
